/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum RejectionLossCode {
  CannotWorkOnAdhocEngagements = "CannotWorkOnAdhocEngagements",
  ConflictOfInterest = "ConflictOfInterest",
  CostTooExpensive = "CostTooExpensive",
  ClientDriven = "ClientDriven",
  ExperienceLackingIndustrySpecificExperience = "ExperienceLackingIndustrySpecificExperience",
  ExperienceOverqualified = "ExperienceOverqualified",
  ExperiencePoorPracticeArea = "ExperiencePoorPracticeArea",
  ExperienceUnderqualified = "ExperienceUnderqualified",
  ExpressedInterestTooLateIntoProcess = "ExpressedInterestTooLateIntoProcess",
  IncorrectLanguage = "IncorrectLanguage",
  InsufficientAvailability = "InsufficientAvailability",
  ProfileNeedsMoreDetail = "ProfileNeedsMoreDetail",
  ProfileNeedsMoreDetailForSubmission = "ProfileNeedsMoreDetailForSubmission",
  QualifiedCandidateThatWasNotSelected = "QualifiedCandidateThatWasNotSelected",
  TimeZoneLocation = "TimeZoneLocation",
  WrongTalentType = "WrongTalentType",
  Other = "Other",
}

export const RejectionLossCodeDisplay: Record<RejectionLossCode, string> = {
  [RejectionLossCode.CannotWorkOnAdhocEngagements]: "Cannot Work On Adhoc Engagements",
  [RejectionLossCode.ConflictOfInterest]: "Conflict Of Interest",
  [RejectionLossCode.CostTooExpensive]: "Cost Too Expensive",
  [RejectionLossCode.ClientDriven]: "Client Driven",
  [RejectionLossCode.ExperienceLackingIndustrySpecificExperience]: "Experience Lacking Industry Specific Experience",
  [RejectionLossCode.ExperienceOverqualified]: "Experience Overqualified",
  [RejectionLossCode.ExperiencePoorPracticeArea]: "Experience Poor Practice Area",
  [RejectionLossCode.ExperienceUnderqualified]: "Experience Underqualified",
  [RejectionLossCode.ExpressedInterestTooLateIntoProcess]: "Expressed Interest Too Late Into Process",
  [RejectionLossCode.IncorrectLanguage]: "Incorrect Language",
  [RejectionLossCode.InsufficientAvailability]: "Insufficient Availability",
  [RejectionLossCode.ProfileNeedsMoreDetail]: "Profile Needs More Detail",
  [RejectionLossCode.ProfileNeedsMoreDetailForSubmission]: "Profile Needs More Detail For Submission",
  [RejectionLossCode.QualifiedCandidateThatWasNotSelected]: "Qualified Candidate That Was Not Selected",
  [RejectionLossCode.TimeZoneLocation]: "Time Zone Location",
  [RejectionLossCode.WrongTalentType]: "Wrong Talent Type",
  [RejectionLossCode.Other]: "Other",
};
